import { mergeApplicationConfig, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appConfig } from './app.config';

/**
 * Browser-specific configuration
 * Contains providers that use browser APIs (animations, etc.)
 */
const browserConfig: ApplicationConfig = {
  providers: [
    provideAnimations()
  ]
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
